export function getSlashParameters(): Record<string, string> {
  const searchParams = new URLSearchParams(window.location.search);
  const slashParameterParts = searchParams.get('')?.split('/');

  if (!slashParameterParts || slashParameterParts.length < 2) {
    return {};
  }

  const result: Record<string, string> = {};
  for (let i = 0; i < slashParameterParts.length - 1; i += 2) {
    result[slashParameterParts[i]] = slashParameterParts[i + 1];
  }

  return result;
}
